export type Country = {
  value: string;
  key: string;
  // code: string;
  alias?: string;
};

export const COUNTRY_LIST: Array<Country> = [
  { value: 'Afghanistan' },
  { value: 'Albania' },
  { value: 'Algeria' },
  { value: 'American Samoa' },
  { value: 'Andorra' },
  { value: 'Angola' },
  { value: 'Anguilla' },
  { value: 'Antarctica' },
  { value: 'Antigua and Barbuda' },
  { value: 'Argentina' },
  { value: 'Armenia' },
  { value: 'Aruba' },
  { value: 'Australia' },
  { value: 'Austria' },
  { value: 'Azerbaijan' },
  { value: 'Bahamas' },
  { value: 'Bahrain' },
  { value: 'Bangladesh' },
  { value: 'Barbados' },
  { value: 'Belarus' },
  { value: 'Belgium' },
  { value: 'Belize' },
  { value: 'Benin' },
  { value: 'Bermuda' },
  { value: 'Bhutan' },
  { value: 'Bolivia' },
  { value: 'Bosnia and Herzegovina' },
  { value: 'Botswana' },
  { value: 'Brazil' },
  { value: 'British Indian Ocean Territory' },
  { value: 'British Virgin Islands' },
  { value: 'Brunei' },
  { value: 'Bulgaria' },
  { value: 'Burkina Faso' },
  { value: 'Burundi' },
  { value: 'Cambodia' },
  { value: 'Cameroon' },
  { value: 'Canada' },
  { value: 'Cape Verde' },
  { value: 'Cayman Islands' },
  { value: 'Central African Republic' },
  { value: 'Chad' },
  { value: 'Chile' },
  { value: 'Mainland China' },
  { value: 'Christmas Island' },
  { value: 'Cocos (Keeling) Islands' },
  { value: 'Colombia' },
  { value: 'Comoros' },
  { value: 'Congo' },
  { value: 'Cook Islands' },
  { value: 'Costa Rica' },
  { value: 'Croatia' },
  { value: 'Cuba' },
  { value: 'Curaçao', alias: 'curacao' },
  { value: 'Cyprus' },
  { value: 'Czech Republic' },
  { value: 'Côte d’Ivoire', alias: "cote d'ivoire, ivory" },
  { value: 'Democratic Republic of the Congo' },
  { value: 'Denmark' },
  { value: 'Djibouti' },
  { value: 'Dominica' },
  { value: 'Dominican Republic' },
  { value: 'Ecuador' },
  { value: 'Egypt' },
  { value: 'El Salvador' },
  { value: 'Equatorial Guinea' },
  { value: 'Eritrea' },
  { value: 'Estonia' },
  { value: 'Ethiopia' },
  { value: 'Falkland Islands' },
  { value: 'Faroe Islands' },
  { value: 'Fiji' },
  { value: 'Finland' },
  { value: 'France' },
  { value: 'French Guiana' },
  { value: 'French Polynesia' },
  { value: 'French Southern Territories' },
  { value: 'Gabon' },
  { value: 'Gambia' },
  { value: 'Georgia' },
  { value: 'Germany', alias: 'deutschland' },
  { value: 'Ghana' },
  { value: 'Gibraltar' },
  { value: 'Greece' },
  { value: 'Greenland' },
  { value: 'Grenada' },
  { value: 'Guadeloupe' },
  { value: 'Guam' },
  { value: 'Guatemala' },
  { value: 'Guernsey' },
  { value: 'Guinea' },
  { value: 'Guinea-Bissau' },
  { value: 'Guyana' },
  { value: 'Haiti' },
  { value: 'Honduras' },
  { value: "Hong Kong S.A.R., People's Republic of China" },
  { value: 'Hungary' },
  { value: 'Iceland' },
  { value: 'India' },
  { value: 'Indonesia' },
  { value: 'Iran' },
  { value: 'Iraq' },
  { value: 'Ireland' },
  { value: 'Isle of Man' },
  { value: 'Israel' },
  { value: 'Italy' },
  { value: 'Jamaica' },
  { value: 'Japan' },
  { value: 'Jersey' },
  { value: 'Jordan' },
  { value: 'Kazakhstan' },
  { value: 'Kenya' },
  { value: 'Kiribati' },
  { value: 'Kuwait' },
  { value: 'Kyrgyzstan' },
  { value: 'Laos' },
  { value: 'Latvia' },
  { value: 'Lebanon' },
  { value: 'Lesotho' },
  { value: 'Liberia' },
  { value: 'Libya' },
  { value: 'Liechtenstein' },
  { value: 'Lithuania' },
  { value: 'Luxembourg' },
  { value: "Macao S.A.R., People's Republic of China" },
  { value: 'Macedonia' },
  { value: 'Madagascar' },
  { value: 'Malawi' },
  { value: 'Malaysia' },
  { value: 'Maldives' },
  { value: 'Mali' },
  { value: 'Malta' },
  { value: 'Marshall Islands' },
  { value: 'Martinique' },
  { value: 'Mauritania' },
  { value: 'Mauritius' },
  { value: 'Mayotte' },
  { value: 'Mexico' },
  { value: 'Micronesia' },
  { value: 'Moldova' },
  { value: 'Monaco' },
  { value: 'Mongolia' },
  { value: 'Montenegro' },
  { value: 'Montserrat' },
  { value: 'Morocco' },
  { value: 'Mozambique' },
  { value: 'Myanmar' },
  { value: 'Namibia' },
  { value: 'Nauru' },
  { value: 'Nepal' },
  { value: 'Netherlands', alias: 'nl, nederlands' },
  { value: 'New Caledonia' },
  { value: 'New Zealand' },
  { value: 'Nicaragua' },
  { value: 'Niger' },
  { value: 'Nigeria' },
  { value: 'Niue' },
  { value: 'Norfolk Island' },
  { value: 'North Korea' },
  { value: 'Northern Mariana Islands' },
  { value: 'Norway' },
  { value: 'Oman' },
  { value: 'Pakistan' },
  { value: 'Palau' },
  { value: 'Palestinian Territory' },
  { value: 'Panama' },
  { value: 'Papua New Guinea' },
  { value: 'Paraguay' },
  { value: 'Peru' },
  { value: 'Philippines' },
  { value: 'Pitcairn' },
  { value: 'Poland' },
  { value: 'Portugal' },
  { value: 'Puerto Rico' },
  { value: 'Qatar' },
  { value: 'Romania' },
  { value: 'Russia' },
  { value: 'Rwanda' },
  { value: 'Réunion', alias: 'reunion' },
  { value: 'Saint Barthélemy' },
  { value: 'Saint Helena' },
  { value: 'Saint Kitts and Nevis' },
  { value: 'Saint Lucia' },
  { value: 'Saint Pierre and Miquelon' },
  { value: 'Saint Vincent and the Grenadines' },
  { value: 'Samoa' },
  { value: 'San Marino' },
  { value: 'Sao Tome and Principe' },
  { value: 'Saudi Arabia' },
  { value: 'Senegal' },
  { value: 'Serbia' },
  { value: 'Seychelles' },
  { value: 'Sierra Leone' },
  { value: 'Singapore' },
  { value: 'Slovakia' },
  { value: 'Slovenia' },
  { value: 'Solomon Islands' },
  { value: 'Somalia' },
  { value: 'South Africa' },
  { value: 'South Korea' },
  { value: 'South Sudan' },
  { value: 'Spain' },
  { value: 'Sri Lanka' },
  { value: 'Sudan' },
  { value: 'Suriname' },
  { value: 'Svalbard and Jan Mayen' },
  { value: 'Swaziland' },
  { value: 'Sweden' },
  { value: 'Switzerland' },
  { value: 'Syria' },
  { value: 'Taiwan' },
  { value: 'Tajikistan' },
  { value: 'Tanzania' },
  { value: 'Thailand' },
  { value: 'Timor-Leste' },
  { value: 'Togo' },
  { value: 'Tokelau' },
  { value: 'Tonga' },
  { value: 'Trinidad and Tobago' },
  { value: 'Tunisia' },
  { value: 'Turkey' },
  { value: 'Turkmenistan' },
  { value: 'Turks and Caicos Islands' },
  { value: 'Tuvalu' },
  { value: 'U.S. Virgin Islands' },
  { value: 'Uganda' },
  { value: 'Ukraine' },
  { value: 'United Arab Emirates' },
  { value: 'United Kingdom', alias: 'gb, uk, great britain, england, scotland, ireland, wales' },
  { value: 'United States', alias: 'us, usa, america' },
  { value: 'United States Minor Outlying Islands' },
  { value: 'Uruguay' },
  { value: 'Uzbekistan' },
  { value: 'Vanuatu' },
  { value: 'Vatican' },
  { value: 'Venezuela' },
  { value: 'Viet Nam', alias: 'vietnam' },
  { value: 'Wallis and Futuna' },
  { value: 'Western Sahara' },
  { value: 'Yemen' },
  { value: 'Zambia' },
  { value: 'Zimbabwe' },
].map((c) => ({ ...c, key: c.value }));
